import React from 'react'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Services() {
    const location = useLocation();
  
    useEffect(() => {
        const name = location.pathname;
        document.body.className = name.substring(1) + "-body";
    }, [location]);
  return (
    <div className="service container">
    <h1 className="service-h1 text-center"> ComTech’s Services </h1>


    <div className="row  justify-content-between  ">
        <div className=" d-flex flex-column col-lg-4 col-md-12 col-sm-12  col-12">
            <div
                className="d-flex align-items-center justify-content-lg-between justify-content-center  main-services-dashed w-100 ">

                <div className="service-element-round">
                    <div></div>

                </div>
                <div
                    className="left-side-service d-flex flex-column justify-content-center mb-lg-0 mt-md-4 mb-md-0 mt-sm-3 mb-sm-0 mt-lg-3 mb-xl-1 mt-xl-0 mt-0 mb-3">
                    <div className="service-heading text-center">Basic Package</div>
                    <div className="dashed-border mb-sm-5 mb-md-5 mb-xl-4 "></div>
                </div>
            </div>


            <div
                className="service-div bggradient service-package mb-sm-4 mb-4 w-md-75 w-sm-75 w-lg-auto w-auto align-self-lg-auto align-self-md-center align-self-sm-center align-self-auto service-pm  ">

                <ul>
                    <li>API for Buy / Sell</li>
                    <li>API for Price Feed</li>
                    <li>API for APP
                        <ul className='list-unstyled p-0'>
                            <li className="custom-dash">API for SIP</li>
                            <li className="custom-dash">API for Redeem</li>
                            <li className="custom-dash">API for Gift</li>
                        </ul>
                    </li>
                    <li>Create your own digital gold</li>
                    <li>Integrated digital platform</li>
                    <li>Physical assets secured with tradeflow warrants</li>
                    <li>Tech support</li>
                </ul>
            </div>
        </div>




        <div className="d-flex flex-column col-lg-4 col-md-12 col-sm-12  col-12">

            <div
                className="d-flex align-items-center justify-content-lg-between justify-content-center w-100 main-services-dashed ">

                <div className="service-element-round">
                    <div></div>

                </div>
                <div
                    className="left-side-service d-flex flex-column justify-content-center mb-lg-0 mt-md-4 mb-md-0 mt-sm-3 mb-sm-0 mt-lg-3 mb-xl-1 mt-xl-0 mt-0 mb-3">
                    <div className="service-heading text-center">Standard Package</div>
                    <div className="dashed-border mb-sm-5 mb-md-5 mb-xl-4 "></div>
                </div>
            </div>
            <div
                className="service-div bggradient service-package mb-sm-4 mb-4 service-pm w-md-75 w-sm-75 w-lg-auto w-auto align-self-lg-auto align-self-md-center align-self-sm-center align-self-auto">
                <ul>
                    <li>All Whitelabel Package 1 features.</li>
                    <li>Custody Support through regulated partners
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Physical custody of assets</li>
                        </ul>
                    </li>
                    <li>Security and Insurance through regulated partners
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Physical assets</li>
                        </ul>
                    </li>
                    <li>Pledging of physical custody using tradeflow warrants</li>
                    <li>OTC Deals of Physical Assets</li>
                    <li>Minting & Burning using Multi-Sig*</li>
                    <li>Tie-ups with distribution vendors for physical assets</li>
                </ul>
            </div>
        </div>



        <div className="d-flex flex-column col-lg-4 col-md-12 col-sm-12  col-12">

            <div
                className="d-flex align-items-center justify-content-lg-between justify-content-center w-100 main-services-dashed ">

                <div className="service-element-round">
                    <div></div>

                </div>
                <div
                    className="left-side-service d-flex flex-column justify-content-center mb-lg-0 mt-md-4 mb-md-0 mt-sm-3 mb-sm-0 mt-lg-3 mb-xl-1 mt-xl-0 mt-0 mb-3">
                    <div className="service-heading text-center">Premium Package</div>
                    <div className="dashed-border mb-sm-5 mb-md-5 mb-xl-4 "></div>
                </div>
            </div>

            <div
                className="service-div bggradient service-package mb-sm-4 mb-4 service-pm w-md-75 w-sm-75 w-lg-auto w-auto align-self-lg-auto align-self-md-center align-self-sm-center align-self-auto">
                <ul >
                    <li>Custody Support through regulated partners
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Physical custody of assets</li>
                        </ul>
                    </li>
                    <li>Security and Insurance through regulated partners
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Physical assets</li>
                        </ul>
                    </li>
                    <li>Pledging of physical custody using tradeflow warrants</li>
                    <li>OTC Deals of Physical Assets</li>
                    <li>Minting & Burning using Multi-Sig*</li>
                    <li>Tie-ups with distribution vendors for physical assets</li>
                </ul>
            </div>
        </div>
    </div>

    <div className="service-disclaimer service-div bggradient service-package mt-4 mb-5 px-3 py-4">
        <h2 className="service-disclaimer-title text-center mb-4">* Technology Platform and Regulatory Responsibility</h2>
        <p>ComTech provides a technology and software infrastructure platform that enables clients to develop, operate and manage their own tokenization and digital asset solutions. The platform is provided solely as a technology and IT solution and does not, by itself, constitute the provision of regulated Virtual Asset services by ComTech.</p>
        <p>ComTech does not act as a Virtual Asset Service Provider (VASP) or provide regulated financial, investment, brokerage, custody, exchange, issuance or other regulated services on behalf of its clients through the provision of the technology platform.</p>
        <p>Clients using the ComTech technology platform are responsible for ensuring that their proposed activities, products and services comply with all applicable laws and regulatory requirements in the jurisdictions in which they operate. It is recommended that clients intending to use the platform for tokenization or Virtual Asset-related activities are appropriately licensed, registered or otherwise authorised by the relevant regulatory authority in their respective jurisdiction, where such authorization is required.</p>
        <p>Each client is solely responsible for obtaining and maintaining any licences, registrations, approvals, consents or other regulatory authorisations required for its business and for ensuring compliance with all applicable laws and regulations, including those relating to Virtual Assets, token issuance, financial services, AML/CFT, sanctions, consumer protection, data protection and securities or investment activities.</p>
        <p>ComTech's role is limited to providing the underlying technology and software infrastructure. ComTech does not assume responsibility for determining whether a client's use of the platform is compliant with the laws or regulatory requirements applicable to that client, nor does the provision of the technology platform constitute an endorsement or confirmation by ComTech that the client's activities are legally or regulatorily authorised.</p>
        <p>Clients remain solely responsible for seeking their own independent legal and regulatory advice and for engaging with the relevant regulatory authorities before commencing any activity that may require regulatory approval or authorisation.</p>
    </div>
</div>
  )
}

export default Services
